import { InjectionToken, Type } from '@angular/core';

// Interface / Rules of our plugin
export interface Plugin {
    name: string;
    icon: string; // SVG string for the sidebar icon
    order?: number; // Optional order to sort plugins in the sidebar
    component: Type<any>;
}

// Creating injection token (unique key in dependency Map of DI) and save it in a variable
export const NG_INAPP_DEV_TOOL_PLUGINS = new InjectionToken<Plugin[]>('NG_INAPP_DEV_TOOL_PLUGINS');